import React, { useState } from "react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [submitted, setSubmitted] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    // Decorative form — does not submit anywhere
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 4000);
    setForm({ name: "", email: "", phone: "", subject: "", message: "" });
  };

  return (
    <div data-testid="page-contact">
      <section className="page-header" data-testid="contact-page-header">
        <div className="container-main">
          <h1>Contact</h1>
          <p>Suntem aici pentru tine</p>
        </div>
      </section>

      <section className="section-white">
        <div className="container-main">
          <div className="contact-card" data-testid="contact-card">
            <div className="contact-icon-big">📞</div>
            <h2>Programează-te Telefonic</h2>
            <p>
              Sună-ne în timpul programului de lucru și unul dintre colegii noștri îți va răspunde
              imediat pentru a stabili o programare.
            </p>
            <a href="tel:+40256123456" className="contact-phone-btn" data-testid="contact-phone-btn">
              📞 0256 123 456
            </a>
            <div className="contact-hours">
              Luni–Vineri: 08:00–20:00 &nbsp;|&nbsp; Sâmbătă: 09:00–14:00
            </div>
          </div>

          <div className="container-main" style={{ padding: 0, maxWidth: 940, marginTop: 40 }}>
            <div className="info-strip" data-testid="info-strip">
              <div className="info-item">
                <div className="info-item-icon">📍</div>
                <div className="info-item-text">Strada Mercy 7, Timișoara 300079</div>
              </div>
              <div className="info-item">
                <div className="info-item-icon">📧</div>
                <div className="info-item-text">contact@dentaproclinic.ro</div>
              </div>
              <div className="info-item">
                <div className="info-item-icon">🅿️</div>
                <div className="info-item-text">Parcare gratuită disponibilă în fața clădirii</div>
              </div>
            </div>

            <div className="map-wrapper" data-testid="map-placeholder">
              <iframe
                title="DentaPro Clinic — Piața Victoriei, Timișoara"
                src="https://www.google.com/maps?q=Pia%C8%9Ba+Victoriei+Timi%C8%99oara&z=16&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <div style={{ textAlign: "center", marginTop: 14 }}>
              <a
                href="https://www.google.com/maps?q=Pia%C8%9Ba+Victoriei+Timi%C8%99oara"
                target="_blank"
                rel="noopener noreferrer"
                className="map-link"
                data-testid="map-link"
              >
                Deschide în Google Maps →
              </a>
            </div>

            {/* Decorative form (no backend) */}
            <div className="contact-form-section">
              <form className="contact-form" onSubmit={onSubmit} data-testid="contact-form">
                <h2>Trimite-ne un Mesaj</h2>
                <p className="contact-form-sub">
                  Completează formularul și echipa noastră îți va răspunde în cel mai scurt timp.
                </p>

                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="name">Nume complet</label>
                    <input
                      className="form-input"
                      id="name"
                      name="name"
                      type="text"
                      placeholder="Numele tău"
                      value={form.name}
                      onChange={onChange}
                      required
                      data-testid="form-input-name"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                      className="form-input"
                      id="email"
                      name="email"
                      type="email"
                      placeholder="email@exemplu.ro"
                      value={form.email}
                      onChange={onChange}
                      required
                      data-testid="form-input-email"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">Telefon</label>
                    <input
                      className="form-input"
                      id="phone"
                      name="phone"
                      type="tel"
                      placeholder="07XX XXX XXX"
                      value={form.phone}
                      onChange={onChange}
                      data-testid="form-input-phone"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="subject">Subiect</label>
                    <select
                      className="form-select"
                      id="subject"
                      name="subject"
                      value={form.subject}
                      onChange={onChange}
                      data-testid="form-input-subject"
                    >
                      <option value="">Alege un subiect</option>
                      <option value="programare">Programare</option>
                      <option value="informatii">Informații tratamente</option>
                      <option value="urgenta">Urgență</option>
                      <option value="altul">Altul</option>
                    </select>
                  </div>
                  <div className="form-group full">
                    <label htmlFor="message">Mesaj</label>
                    <textarea
                      className="form-textarea"
                      id="message"
                      name="message"
                      placeholder="Spune-ne cum te putem ajuta..."
                      value={form.message}
                      onChange={onChange}
                      required
                      data-testid="form-input-message"
                    />
                  </div>
                  <div className="form-group full">
                    <button type="submit" className="btn btn-primary form-submit" data-testid="form-submit-btn">
                      Trimite Mesajul
                    </button>
                    {submitted && (
                      <div
                        style={{
                          marginTop: 14,
                          padding: 14,
                          borderRadius: 10,
                          background: "rgba(10,147,150,0.12)",
                          color: "#0A9396",
                          fontWeight: 700,
                          textAlign: "center",
                        }}
                        data-testid="form-success-message"
                      >
                        Mulțumim! Mesajul tău a fost trimis. Te vom contacta în curând.
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
